import { mount } from "@vue/test-utils";
import MoreInfo from "@/components/core/modals/MoreInfo";

describe("MoreInfo component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(MoreInfo);
  });

  it("Renders del component MoreInfo", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
